import { render } from "./PaperModalContainer.vue?vue&type=template&id=6344c07e"
import script from "./PaperModalContainer.vue?vue&type=script&lang=js"
export * from "./PaperModalContainer.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PaperModalContainer.vue?vue&type=style&index=0&id=6344c07e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__